export const vasChargeType = {
  UNION: 'UNION',
  MHE: 'MHE',
  DEDICATED: 'DEDICATED_VEHICLE'
};

export const locationTypeOptions = [
  {
    key: 'CWH',
    value: 'CWH'
  },
  {
    key: 'RIVIGO',
    value: 'Rivigo Location'
  }
];

export const entityTypeOptions = [
  {
    key: 'PRS',
    val: 'PRS'
  },
  {
    key: 'TRIP',
    val: 'TRIP'
  },
  {
    key: 'DRS',
    val: 'DRS'
  }
];

export const entityTypeOptionsDedicatedVehicle = [
  {
    key: 'PRS',
    val: 'PRS'
  },
  {
    key: 'DRS',
    val: 'DRS'
  }
];

export const chargeBasisOptions = [
  {
    key: 'RATE_PER_CN',
    val: 'RATE PER CN'
  },
  {
    key: 'RATE_PER_BOX',
    val: 'RATE PER BOX'
  },
  {
    key: 'LUMPSUM_AMOUNT',
    val: 'LUMPSUM AMOUNT'
  }
];

export const chargeBasisOptionsDedicatedVehicle = [
  {
    key: 'LUMPSUM_AMOUNT',
    val: 'LUMPSUM AMOUNT'
  }
];

export const activityTypeOptions = [
  {
    key: 'LOADING',
    val: 'LOADING'
  },
  {
    key: 'UNLOADING',
    val: 'UNLOADING'
  }
];

export const isImageOrPdf = file => {
  if (!file) return false;
  if (typeof file === 'string') {
    const lower = file.toLowerCase();
    return [
      '.jpg',
      '.jpeg',
      '.png',
      '.gif',
      '.bmp',
      '.webp',
      '.pdf'
    ].some(ext => lower.includes(ext));
  }
  const mimeType = file.type ? file.type.toLowerCase() : '';
  const fileName = file.name ? file.name.toLowerCase() : '';
  const validExtensions = [
    '.jpg',
    '.jpeg',
    '.png',
    '.gif',
    '.bmp',
    '.webp',
    '.pdf'
  ];

  const hasValidMime =
    mimeType.startsWith('image/') || mimeType === 'application/pdf';
  const hasValidExt = validExtensions.some(ext => fileName.endsWith(ext));

  return hasValidMime || hasValidExt;
};
